// Display-only helpers. The server quote is authoritative for pricing and rewards.
export function amountMinor(text) {
  const value = String(text).trim().replace(',', '.')
  if (!/^\d{1,7}(\.\d{0,2})?$/.test(value)) return null
  const [whole, fraction = ''] = value.split('.')
  return Number(whole) * 100 + Number(fraction.padEnd(2, '0'))
}

export function previewCredits(minor, currency, anchors) {
  if (!Number.isSafeInteger(minor)) return 0
  const eligible = anchors.filter(a => a.currency === currency && a.priceMinor > 0 && a.priceMinor <= minor)
  const anchor = eligible.sort((a, b) => b.priceMinor - a.priceMinor)[0]
  return anchor ? Math.floor((minor * anchor.credits) / (anchor.priceMinor * 100)) * 100 : 0
}

export function wheelSlices(wheel) {
  if (!wheel || !Array.isArray(wheel.prizes) || !(wheel.totalWeight > 0)) return []
  let start = 0
  return wheel.prizes.filter(p => p.weight > 0).map(prize => {
    const degrees = (prize.weight / wheel.totalWeight) * 360
    const slice = {
      ...prize, start, degrees, percent: (prize.weight / wheel.totalWeight) * 100,
    }
    start += degrees
    return slice
  })
}

export function wheelRestingRotation(slice) {
  const target = 360 - (slice.start + slice.degrees / 2)
  return ((target % 360) + 360) % 360
}

export function wheelRotation(current, slice) {
  const target = wheelRestingRotation(slice)
  return current + 5 * 360 + ((target - (current % 360) + 360) % 360)
}

export function escapePaymentValue(value) {
  return String(value == null ? '' : value).replace(/[&<>"']/g, ch => ({
    '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;',
  }[ch]))
}

export const activePaymentStates = ['initializing', 'init_unknown', 'checkout', 'capturing', 'capture_unknown', 'captured']
export const editableOfferStates = ['quoted', 'wheel_ready', 'spun']
